import script from "./InfoFields.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoFields.vue?vue&type=script&lang=ts&setup=true"

import "./InfoFields.vue?vue&type=style&index=0&id=7318cf56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7318cf56"]])

export default __exports__